export default {
	page_title: 'Digitální archiv',
	homepage: 'Úvod',
	search: 'Vyhledávání',
	help: 'Nápověda',
	contact: 'Kontakt',
	menu_icon_tooltip: 'Menu',
};
